<template>
  <div class="knowledge scroll">
    <div v-for="(item, i) in list[type]" :key="i">
      <div v-if="item.type == 'title'" class="title">
        <div class="point"></div>
        {{ $t(item.content) }}
      </div>
      <div v-else-if="item.type == 'text'" class="text">
        {{ $t(item.content) }}
      </div>
      <div v-else-if="item.type == 'image'" class="image">
        <img :src="item.content" alt="" />
      </div>
      <div v-else-if="item.type == 'list'" class="list">
        <p v-show="item.title">{{ $t(item.title) }}</p>
        <div v-for="(text, m) in item.content" :key="m" class="text">
          {{ $t(text) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'knowledge',
  components: {},
  props: ['type'],
  data() {
    return {
      list: [
        [
          {
            type: 'title',
            content: 'lang.ct.two.one.zs_child.first.title',
          },
          {
            type: 'text',
            content: 'lang.ct.two.one.zs_child.first.content',
          },
          {
            type: 'image',
            content: '/images/knowledge/0-1.png',
          },
          {
            type: 'image',
            content: '/images/knowledge/0-2.png',
          },
          {
            type: 'title',
            content: 'lang.ct.two.one.zs_child.second.title',
          },
          {
            type: 'image',
            content: '/images/knowledge/0-3.png',
          },
          {
            type: 'text',
            content: 'lang.ct.two.one.zs_child.second.content',
          },
          {
            type: 'title',
            content: 'lang.ct.two.one.zs_child.third.title',
          },
          {
            type: 'text',
            content: 'lang.ct.two.one.zs_child.third.content',
          },
          {
            type: 'title',
            content: 'lang.ct.two.one.zs_child.fourth.title',
          },
          {
            type: 'image',
            content: '/images/knowledge/0-4.png',
          },
        ],
        [
          {
            type: 'title',
            content: 'lang.ct.two.two.zs_child.first.title',
          },
          {
            type: 'text',
            content: 'lang.ct.two.two.zs_child.first.line1',
          },
          {
            type: 'text',
            content: 'lang.ct.two.two.zs_child.first.line2',
          },
          {
            type: 'text',
            content: 'lang.ct.two.two.zs_child.first.line3',
          },
          {
            type: 'text',
            content: 'lang.ct.two.two.zs_child.first.line4',
          },
          {
            type: 'title',
            content: 'lang.ct.two.two.zs_child.second.title',
          },
          {
            type: 'image',
            content: '/images/knowledge/1-1.png',
          },
          {
            type: 'image',
            content: '/images/knowledge/1-2.png',
          },
          {
            type: 'title',
            content: 'lang.ct.two.two.zs_child.third.title',
          },
          {
            type: 'list',
            title: 'lang.ct.two.two.zs_child.third.type1.exp',
            content: [
              'lang.ct.two.two.zs_child.third.type1.exp_title',
              'lang.ct.two.two.zs_child.third.type1.line1',
              'lang.ct.two.two.zs_child.third.type1.line2',
              'lang.ct.two.two.zs_child.third.type1.line3',
              'lang.ct.two.two.zs_child.third.type1.line4',
              'lang.ct.two.two.zs_child.third.type1.line5',
            ],
          },
          {
            type: 'list',
            title: 'lang.ct.two.two.zs_child.third.type2.exp',
            content: [
              'lang.ct.two.two.zs_child.third.type2.line1',
              'lang.ct.two.two.zs_child.third.type2.line2',
              'lang.ct.two.two.zs_child.third.type2.line3',
            ],
          },
          {
            type: 'list',
            title: 'lang.ct.two.two.zs_child.third.type3.exp',
            content: [
              'lang.ct.two.two.zs_child.third.type3.line1',
              'lang.ct.two.two.zs_child.third.type3.line2',
              'lang.ct.two.two.zs_child.third.type3.line3',
              'lang.ct.two.two.zs_child.third.type3.line4',
            ],
          },
          {
            type: 'list',
            title: 'lang.ct.two.two.zs_child.third.type4.exp',
            content: ['lang.ct.two.two.zs_child.third.type4.line1'],
          },
          {
            type: 'lang.ct.two.two.zs_child.third.type5.exp',
            title: '灯梁：',
            content: [
              'lang.ct.two.two.zs_child.third.type5.line1',
              'lang.ct.two.two.zs_child.third.type5.line2',
            ],
          },
          {
            type: 'list',
            title: 'lang.ct.two.two.zs_child.third.type6.exp',
            content: [
              'lang.ct.two.two.zs_child.third.type6.line1',
              'lang.ct.two.two.zs_child.third.type6.line2',
              'lang.ct.two.two.zs_child.third.type6.line3',
            ],
          },
          {
            type: 'list',
            title: 'lang.ct.two.two.zs_child.third.type7.exp',
            content: [
              'lang.ct.two.two.zs_child.third.type7.line1',
              'lang.ct.two.two.zs_child.third.type7.line2',
            ],
          },
          {
            type: 'image',
            content: '/images/knowledge/1-3.png',
          },
          {
            type: 'list',
            title: 'lang.ct.two.two.zs_child.third.type8.exp',
            content: [
              'lang.ct.two.two.zs_child.third.type8.line1',
              'lang.ct.two.two.zs_child.third.type8.line2',
              'lang.ct.two.two.zs_child.third.type8.line3',
            ],
          },
          {
            type: 'list',
            title: 'lang.ct.two.two.zs_child.third.type9.exp',
            content: [
              'lang.ct.two.two.zs_child.third.type9.line1',
              'lang.ct.two.two.zs_child.third.type9.line2',
            ],
          },
          {
            type: 'list',
            title: 'lang.ct.two.two.zs_child.third.type10.exp',
            content: [
              'lang.ct.two.two.zs_child.third.type10.line1',
              'lang.ct.two.two.zs_child.third.type10.line2',
            ],
          },
          {
            type: 'list',
            title: 'lang.ct.two.two.zs_child.third.type11.exp',
            content: [
              'lang.ct.two.two.zs_child.third.type11.line1',
              'lang.ct.two.two.zs_child.third.type11.line2',
              'lang.ct.two.two.zs_child.third.type11.line3_title',
              'lang.ct.two.two.zs_child.third.type11.line3_1',
            ],
          },
          {
            type: 'image',
            content: '/images/knowledge/1-4.png',
          },
          {
            type: 'text',
            content: 'lang.ct.two.two.zs_child.third.type11.line3_2',
          },
          {
            type: 'image',
            content: '/images/knowledge/1-5.png',
          },
          {
            type: 'text',
            content: 'lang.ct.two.two.zs_child.third.type11.line3_3',
          },
          {
            type: 'text',
            content: 'lang.ct.two.two.zs_child.third.type11.line3_4',
          },
          {
            type: 'image',
            content: '/images/knowledge/1-6.png',
          },
          {
            type: 'image',
            content: '/images/knowledge/1-7.png',
          },
          {
            type: 'image',
            content: '/images/knowledge/1-8.png',
          },
          {
            type: 'text',
            content: 'lang.ct.two.two.zs_child.third.type11.line3_5',
          },
          {
            type: 'text',
            content: 'lang.ct.two.two.zs_child.third.type11.line3_6',
          },
          {
            type: 'image',
            content: '/images/knowledge/1-9.png',
          },
          {
            type: 'text',
            content: 'lang.ct.two.two.zs_child.third.type11.line3_7',
          },
          {
            type: 'text',
            content: 'lang.ct.two.two.zs_child.third.type11.line3_8',
          },
          {
            type: 'image',
            content: '/images/knowledge/1-10.png',
          },
          {
            type: 'text',
            content:
              'lang.ct.two.two.zs_child.third.type11.line3_9_title_line1',
          },
          {
            type: 'text',
            content:
              'lang.ct.two.two.zs_child.third.type11.line3_9_title_line2',
          },
          {
            type: 'text',
            content: 'lang.ct.two.two.zs_child.third.type11.line3_9_1',
          },
          {
            type: 'text',
            content: 'lang.ct.two.two.zs_child.third.type11.line3_9_2',
          },
          {
            type: 'image',
            content: '/images/knowledge/1-11.png',
          },
          {
            type: 'list',
            title: '',
            content: [
              'lang.ct.two.two.zs_child.third.type11.line3_9_3',
              'lang.ct.two.two.zs_child.third.type11.line3_9_4',
              'lang.ct.two.two.zs_child.third.type11.line3_9_5',
              'lang.ct.two.two.zs_child.third.type11.line3_9_6',
            ],
          },
          {
            type: 'list',
            title: 'lang.ct.two.two.zs_child.third.type12.exp',
            content: [
              'lang.ct.two.two.zs_child.third.type12.line1',
              'lang.ct.two.two.zs_child.third.type12.line2',
              'lang.ct.two.two.zs_child.third.type12.line3',
              'lang.ct.two.two.zs_child.third.type12.line4',
            ],
          },
          {
            type: 'image',
            content: '/images/knowledge/1-12.png',
          },
        ],
        [
          {
            type: 'list',
            title: '',
            content: [
              'lang.ct.two.three.zs_child.line1',
              'lang.ct.two.three.zs_child.line2',
              'lang.ct.two.three.zs_child.line3',
              'lang.ct.two.three.zs_child.line4',
              'lang.ct.two.three.zs_child.line5',
              'lang.ct.two.three.zs_child.line6',
              'lang.ct.two.three.zs_child.line7',
              'lang.ct.two.three.zs_child.line8',
            ],
          },
          {
            type: 'list',
            title: 'lang.ct.two.three.zs_child.type1.exp',
            content: ['lang.ct.two.three.zs_child.type1.line1'],
          },
          {
            type: 'list',
            title: 'lang.ct.two.three.zs_child.type2.exp',
            content: [
              'lang.ct.two.three.zs_child.type2.line1',
              'lang.ct.two.three.zs_child.type2.line2',
              'lang.ct.two.three.zs_child.type2.line3',
            ],
          },
          {
            type: 'image',
            content: '/images/knowledge/2-1.png',
          },
          {
            type: 'list',
            title: '',
            content: [
              'lang.ct.two.three.zs_child.type2.line4',
              'lang.ct.two.three.zs_child.type2.line5',
            ],
          },
          {
            type: 'image',
            content: '/images/knowledge/2-2.png',
          },
          {
            type: 'text',
            content: 'lang.ct.two.three.zs_child.type2.line6',
          },
          {
            type: 'image',
            content: '/images/knowledge/2-3.png',
          },
        ],
        [
          {
            type: 'title',
            content: 'lang.ct.two.four.zs_child.first.type1.exp',
          },
          {
            type: 'text',
            content: 'lang.ct.two.four.zs_child.first.type1.line1',
          },
          {
            type: 'list',
            title: 'lang.ct.two.four.zs_child.first.type1.line2',
            content: [
              'lang.ct.two.four.zs_child.first.type1.line3',
              'lang.ct.two.four.zs_child.first.type1.line4',
              ,
              'lang.ct.two.four.zs_child.first.type1.line5',
            ],
          },
          {
            type: 'list',
            title: 'lang.ct.two.four.zs_child.first.type2.exp',
            content: ['lang.ct.two.four.zs_child.first.type2.line1'],
          },
          {
            type: 'image',
            content: '/images/knowledge/3-1.png',
          },
          {
            type: 'list',
            title: 'lang.ct.two.four.zs_child.first.type3.exp',
            content: ['lang.ct.two.four.zs_child.first.type3.line1'],
          },
          {
            type: 'image',
            content: '/images/knowledge/3-2.png',
          },
          {
            type: 'list',
            title: 'lang.ct.two.four.zs_child.first.type3.line2',
            content: [],
          },
          {
            type: 'list',
            title: 'lang.ct.two.four.zs_child.first.type3.line3',
            content: ['lang.ct.two.four.zs_child.first.type3.line4'],
          },
          {
            type: 'title',
            content: 'lang.ct.two.four.zs_child.second.type1.exp',
          },
          {
            type: 'text',
            content: 'lang.ct.two.four.zs_child.second.type1.line1',
          },
          {
            type: 'image',
            content: '/images/knowledge/3-3.png',
          },
          {
            type: 'image',
            content: '/images/knowledge/3-4.png',
          },
        ],
      ],
    }
  },
  watch: {},
  computed: {},
  created() {},
  mounted() {},
  methods: {},
}
</script>

<style lang="scss" scoped>
.knowledge {
  width: 100%;
  height: 100%;
  background: hsla(0, 0%, 100%, 0.95);
  box-shadow: 0 2px 24px 0 rgb(221 241 255 / 49%);
  border-radius: 5px;
  padding: 35px 90px;
  font-size: 16px;
  line-height: 28px;
  .title {
    margin-top: 0;
    position: relative;
    font-weight: bold;
    margin: 5px 0;
    .point {
      position: absolute;
      top: 0;
      left: -10px;
      width: 3px;
      height: 100%;
      background-color: var(--exp-color);
      border-radius: 2px;
    }
  }
  .text {
    text-indent: 2rem;
  }
  .image {
    display: flex;
    justify-content: center;
  }
  .list {
    p {
      font-weight: bold;
      margin: 0;
    }
  }
}
</style>